import { render, staticRenderFns } from "./GrowPropertiesWeaning.vue?vue&type=template&id=0c33e021"
import script from "./GrowPropertiesWeaning.vue?vue&type=script&lang=js"
export * from "./GrowPropertiesWeaning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports